/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */
'use strict'; // const UIManager = require('../ReactNative/UIManager');

/**
 * Adds a deprecation warning when the prop is used.
 */

function deprecatedPropType(propType, explanation) {
  return function validate(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    // Don't warn for native components.
    // if (
    //   !UIManager.getViewManagerConfig(componentName) &&
    //   props[propName] !== undefined
    // ) {
    //   console.warn(
    //     `\`${propName}\` supplied to \`${componentName}\` has been deprecated. ${explanation}`,
    //   );
    // }
    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}

module.exports = deprecatedPropType;